import { React, lazy } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { dogActions } from "../../store";

const Container = lazy(() => import("../../common/Container"));

const PetName = () => {
  const dispatch = useDispatch();
  const pet_name = useSelector((state) => state.dog.pet_name);

  const addLetters = (event) => {
    dispatch(dogActions.addPetName(event.target.value));
  };

  return (
    <Container padding={200}>
      <h1 className="is-title">
        Before we start we need to know your Dog's name
      </h1>
      <div className="field">
        <label className="label">Your Pets' Name</label>
        <div className="control">
          <input
            className="input is-medium"
            type="text"
            placeholder="What is your pet's name"
            onChange={addLetters}
            value={pet_name}
          />
        </div>
      </div>
      <footer>
        <Link to="/quote">
          <button type="submit" className="button is-success">
            Proceed
          </button>
        </Link>
      </footer>
    </Container>
  );
};

export default PetName;
